import decodeJwt from 'jwt-decode'

const useUser = () => {
  const storedProfile = window.localStorage.getItem('feathers-jwt')
  const id = storedProfile ? decodeJwt(storedProfile).sub : null

  return {
    id
  }
}

export default useUser
